import * as React from 'react';

import {Dialog} from 'shells/dialog/dialog';

import {appHistory} from '../../../../history';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    anchorElementId: string;
};

export function PhoneSettingsDialog(props: Props) {
    const handleGoToSettings = () => {
        appHistory.push('/my-account/phone');
        props.onClose();
    };

    if (!props.isOpen) {
        return null;
    }

    return (
        <Dialog
            anchor={null}
            anchorElementId={props.anchorElementId}
            question='Select a default phone provider first'
            primaryText='Go to phone settings'
            tertiaryText='Cancel'
            onPrimary={handleGoToSettings}
            onTertiary={props.onClose}
            primaryVariant='primary'
            tertiaryVariant='secondary'
            onBlur={props.onClose}
            location='bottom'
        />
    );
}
